import React from 'react'
import { Outlet } from 'react-router-dom'

const ForgetPasswordLayout = () => {
    return (
        <Outlet />
    )
}

export default ForgetPasswordLayout